import React, {useEffect, useState} from 'react';
import { toast } from 'react-toastify';
import Http from "../../../http";
import Transition from "../../../utils/transition";
import ENTRY_STATUS from "../../../constants/entry-status";
import ENTRY_MANAGEMENT_STATUS from "../../../constants/entry-management-status";
import IRREGULAR_STATUS from "../../../constants/irregular-status";
import EntryStatus from "../../atoms/entry-status";
import EntryManagementStatus from "../../atoms/entry-management-status";
import IrregularStatus from "../../atoms/irregular-status";
import { FormatUtil, SelectInput, UrlUtil } from "@graffer-inc/graffer-ui";
import APPLICATION_TYPE from "../../../constants/application-type";

const Main = () => {
  const params = UrlUtil.parseQueryOf(window.location.search);
  const [entries, setEntries] = useState(null);
  const [entryStatus, setEntryStatus] = useState(params.entryStatus || '');
  const [entryManagementStatus, setEntryManagementStatus] = useState(params.entryManagementStatus || '');
  const [irregularStatus, setIrregularStatus] = useState(params.irregularStatus || '');

  useEffect(() => {
    const fetchAllEntries = async () => {
      await Http.fetchAllEntries(
        params.entryStatus, params.entryManagementStatus, params.irregularStatus,
        res => setEntries(res.data.entries),
        (err) => {
          if ([401, 403].includes(err.response.status)) {
            Transition.goToEmsLogin();
          } else {
            toast.error('申込一覧の取得に失敗しました。画面をリロードまたは再ログインしてください。');
          }
        }
      );
    };
    fetchAllEntries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <p className="is-size-3 has-text-weight-bold">電子証明書取得サポート - 申込一覧</p>
      <br/>
      <div style={{padding: '0 0 20px 0', justifyContent: 'space-between'}} className='is-flex'>
        <div className='is-flex'>
        <span style={{padding: '0 5px 0 0'}}>
          <SelectInput
            value={entryStatus}
            options={[{value: '', name: '-- ユーザーステータス --'}, ...Object.values(ENTRY_STATUS.CODE).map(code => {
              return {value: code, name: ENTRY_STATUS.name(code)};
            }), {value: 'REFUNDED', name: 'キャンセル'}]}
            onChange={setEntryStatus}
          />
        </span>
          <span style={{padding: '0 5px 0 0'}}>
          <SelectInput
            value={entryManagementStatus}
            options={[{value: '', name: '-- 管理ステータス --'}, ...Object.values(ENTRY_MANAGEMENT_STATUS.CODE).map(code => {
              return {value: code, name: ENTRY_MANAGEMENT_STATUS.name(code)};
            })]}
            onChange={setEntryManagementStatus}
          />
        </span>
          <span style={{padding: '0 5px 0 0'}}>
          <SelectInput
            value={irregularStatus}
            options={[{value: '', name: '-- イレギュラーステータス --'}, ...Object.values(IRREGULAR_STATUS.CODE).map(code => {
              return {value: code, name: IRREGULAR_STATUS.name(code)};
            })]}
            onChange={setIrregularStatus}
          />
        </span>
        </div>
        <div>
        <span style={{padding: '0 5px 0 0'}}>
          <button className='button is-info' onClick={() => {
            Transition.goToExternal(`${process.env.REACT_APP_BASE_URL}/ems/entries/?entryStatus=${entryStatus}&entryManagementStatus=${entryManagementStatus}&irregularStatus=${irregularStatus}`)
          }}>検索する</button>
        </span>
          <span>
          <button className='button' onClick={() => {
            setEntryStatus('');
            setEntryManagementStatus('');
            setIrregularStatus('');
          }}>リセット</button>
        </span>
        </div>
      </div>
      <table className="table is-fullwidth list is-size-7">
        <thead>
        <tr>
          <th>申込番号</th>
          <th>申込者ID / 申込者名</th>
          <th>申込法人名 / 申請プラン / 証明期間</th>
          <th>申込日時</th>
          <th>ステータス</th>
        </tr>
        </thead>
        <tbody>
        {entries && entries.map(e => {
          return (
            <tr key={e.id}>
              <td style={{height: '100px', verticalAlign: 'middle'}}><a href={`/ems/entries/${e.id}`}>{e.id}</a></td>
              <td style={{height: '100px', verticalAlign: 'middle'}}>
                {e.userId}
                <br/>
                {e.userName}
              </td>
              <td style={{height: '100px', verticalAlign: 'middle'}}>
                {e.corporateName}
                <br/>
                {`${APPLICATION_TYPE.name(e.applicationType)}プラン`}
                <br/>
                {`${e.certPeriod}ヵ月`}
              </td>
              <td style={{height: '100px', verticalAlign: 'middle'}}>
                {FormatUtil.dateWithTime(e.createdAt)}
              </td>
              <td style={{height: '100px', verticalAlign: 'middle'}}>
                <p style={{padding: '3px 0'}}>
                  <span className="is-size-7 has-text-grey">ユーザー: </span>
                  <EntryStatus status={e.status} isRefunded={e.isRefunded} desktopFontSize="is-size-7" />
                </p>
                <p style={{padding: '3px 0'}}>
                  <span className="is-size-7 has-text-grey">管理: </span>
                  <EntryManagementStatus status={e.entryManagementStatus} desktopFontSize="is-size-7" />
                </p>
                <p style={{padding: '3px 0'}}>
                  <span className="is-size-7 has-text-grey">イレギュラー: </span>
                  <IrregularStatus status={e.irregularStatus} desktopFontSize="is-size-7" />
                </p>
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
      <br/>
    </div>
  )
};

export default Main;